import React from 'react';
import { Container, Button, Row, Col, Card } from 'react-bootstrap';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import { FaSignInAlt } from 'react-icons/fa';
import './home.css';

const BASE_TITLE = process.env.REACT_APP_BASE_TITLE;

const features = [
    {
        icon: '📞',
        title: 'Consulta por Teléfono',
        description: 'Identifica a un cliente AFP Capital a partir de su número telefónico en segundos.',
    },
    {
        icon: '🔍',
        title: 'Información Instantánea',
        description: 'Accede a datos básicos del afiliado de forma rápida y segura para mejorar la atención.',
    },
    {
        icon: '🔒',
        title: 'Acceso Seguro',
        description: 'Plataforma protegida con autenticación corporativa mediante tu usuario de red.',
    },
];

export default function Home() {
    const { instance } = useMsal();

    const handleLogin = () => {
        instance.loginPopup(loginRequest).catch((e) => console.log(e));
    };

    return (
        <div className="landing-wrapper">
            {/* Hero */}
            <section className="landing-hero">
                <Container className="landing-hero-inner">
                    <div className="landing-badge">AFP Capital</div>
                    <h1 className="landing-title">{BASE_TITLE}</h1>
                    <p className="landing-subtitle">
                        Consulta información básica de afiliados a partir de su número telefónico,
                        de forma rápida, segura y desde cualquier lugar de la red corporativa.
                    </p>
                    <Button
                        className="landing-cta-btn"
                        size="lg"
                        onClick={handleLogin}
                    >
                        <FaSignInAlt className="me-2" />
                        Iniciar Sesión con usuario de red
                    </Button>
                    <p className="landing-hint">Usa tus credenciales corporativas &mdash; acceso seguro mediante tu usuario de red</p>
                </Container>
            </section>

            {/* Feature cards */}
            <section className="landing-features">
                <Container>
                    <Row className="g-4 justify-content-center">
                        {features.map((f, i) => (
                            <Col key={i} xs={12} sm={6} md={4}>
                                <Card className="feature-card h-100">
                                    <Card.Body>
                                        <div className="feature-icon">{f.icon}</div>
                                        <Card.Title className="feature-title">{f.title}</Card.Title>
                                        <Card.Text className="feature-text">{f.description}</Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
        </div>
    );
}